import React from 'react';
import { useTranslation } from 'react-i18next';
import './KitLumina.css';

const KitLumina = () => {
  const { t } = useTranslation();
  
  return (
    <div className="kit-lumina-page">
      {/* Hero Section */}
      <section className="kit-hero">
        <div className="container">
          <div className="kit-hero-image" style={{ backgroundImage: 'image-set(url(/images/kt01_kt.webp) type("image/webp"), url(/images/kt01_kt.png) type("image/png"))' }}>
            <h2 className="kit-hero-subtitle">
              {t('kit.heroSubtitle', { defaultValue: 'Porque se cuidar nunca foi tão simples, seguro e respeitoso.' })}
            </h2>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="kit-video-section">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">{t('kit.pageVideoTitle')}</h2>
          <div className="video-content" data-aos="fade-up" data-aos-delay="200">
            <div className="video-image" style={{ backgroundImage: 'image-set(url(/images/kt02_kt.webp) type("image/webp"), url(/images/kt02_kt.png) type("image/png"))' }}></div>
            <p className="video-description">
              {t('kit.pageVideoDescription')}
            </p>
            <button className="btn btn-primary">{t('kit.pageVideoButton')}</button>
          </div>
        </div>
      </section>

      {/* Kit Description */}
      <section className="kit-description">
        <div className="container">
          <div className="description-content">
            <div data-aos="fade-right">
              <h2 className="description-title">{t('kit.pageDescriptionTitle')}</h2>
              <p className="description-paragraph">
                {t('kit.pageDescriptionText')}
              </p>
            </div>
            <div className="description-image" data-aos="fade-left">
              <picture>
                <source type="image/webp" srcSet="/images/kt_mock.webp" />
                <img src="/images/kt_mock.png" alt="Kit Lumina" />
              </picture>
            </div>
          </div>

          <div className="features-grid">
            <div className="feature-card" data-aos="fade-up" data-aos-delay="200">
              <div className="feature-icon">
                <picture>
                  <source type="image/webp" srcSet="/images/kt01_ico_kt.webp" />
                  <img src="/images/kt01_ico_kt.png" alt="Feature 1" />
                </picture>
              </div>
              <p className="feature-text">
                {t('kit.pageFeature1')}
              </p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="300">
              <div className="feature-icon">
                <picture>
                  <source type="image/webp" srcSet="/images/kt02_ico_kt.webp" />
                  <img src="/images/kt02_ico_kt.png" alt="Feature 2" />
                </picture>
              </div>
              <p className="feature-text">
                {t('kit.pageFeature2')}
              </p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="400">
              <div className="feature-icon">
                <picture>
                  <source type="image/webp" srcSet="/images/kt03_ico_kt.webp" />
                  <img src="/images/kt03_ico_kt.png" alt="Feature 3" />
                </picture>
              </div>
              <p className="feature-text">
                {t('kit.pageFeature3')}
              </p>
            </div>
            <div className="feature-card" data-aos="fade-up" data-aos-delay="500">
              <div className="feature-icon">
                <picture>
                  <source type="image/webp" srcSet="/images/kt04_ico_kt.webp" />
                  <img src="/images/kt04_ico_kt.png" alt="Feature 4" />
                </picture>
              </div>
              <p className="feature-text">
                {t('kit.pageFeature4')}
              </p>
            </div>
          </div>

          <div className="cta-button-container" data-aos="fade-up" data-aos-delay="600">
            <button className="btn btn-primary">{t('kit.pageCTAButton')}</button>
          </div>
        </div>
      </section>

      {/* Steps Section */}
      <section className="kit-steps">
        <div className="container">
          <div className="kit-steps-grid" data-aos="fade-up">
            <div className="kit-step-card">
              <div className="kit-step-image">
                <img src="/images/kt_in_01.png" alt="Preparar o dispositivo" />
              </div>
              <p className="kit-step-title"><strong>{t('kit.steps.title1')}</strong></p>
              <p className="kit-step-caption">{t('kit.steps.step1')}</p>
            </div>
            <div className="kit-step-card">
              <div className="kit-step-image">
                <img src="/images/kt_in_02.png" alt="Posição confortável" />
              </div>
              <p className="kit-step-title"><strong>{t('kit.steps.title2')}</strong></p>
              <p className="kit-step-caption">{t('kit.steps.step2')}</p>
            </div>
            <div className="kit-step-card">
              <div className="kit-step-image">
                <img src="/images/kt_in_03.png" alt="Inserção e coleta" />
              </div>
              <p className="kit-step-title"><strong>{t('kit.steps.title3')}</strong></p>
              <p className="kit-step-caption">{t('kit.steps.step3')}</p>
            </div>
            <div className="kit-step-card">
              <div className="kit-step-image">
                <img src="/images/kt_in_04.png" alt="Transferência para o tubo" />
              </div>
              <p className="kit-step-title"><strong>{t('kit.steps.title4')}</strong></p>
              <p className="kit-step-caption">{t('kit.steps.step4')}</p>
            </div>
            <div className="kit-step-card">
              <div className="kit-step-image">
                <img src="/images/kt_in_05.png" alt="Teste rápido HPV" />
              </div>
              <p className="kit-step-title"><strong>{t('kit.steps.title5')}</strong></p>
              <p className="kit-step-caption">{t('kit.steps.step5')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Image Section */}
      <section className="kit-additional-image">
        <div className="container">
          <div className="kit-additional-image-content" style={{ backgroundImage: 'image-set(url(/images/kt04_kt.webp) type("image/webp"), url(/images/kt04_kt.png) type("image/png"))' }}>
            <div className="additional-image-overlay-title">
              {t('kit.finalImageTitle', { defaultValue: 'A Lumina está com você, do início ao fim' })}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="kit-cta">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text-section" data-aos="fade-right">
              <h2 className="cta-title">{t('kit.pageFinalTitle')}</h2>
              <p className="cta-description">
                {t('kit.pageFinalDescription')}
              </p>
              <button className="btn btn-primary">{t('kit.pageFinalButton')}</button>
            </div>
            <div className="cta-image-section" data-aos="fade-left">
              <picture>
                <source type="image/webp" srcSet="/images/kt_final.webp" />
                <img src="/images/kt_final.png" alt="Kit Lumina Final" className="cta-image" />
              </picture>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KitLumina;
